const REDIRECT_AFTER_AUTH_KEY = 'redirectAfterAuth';

export const saveRedirectPath = (path: string): void => {
  sessionStorage.setItem(REDIRECT_AFTER_AUTH_KEY, path);
};

export const getRedirectPath = (): string | null => {
  return sessionStorage.getItem(REDIRECT_AFTER_AUTH_KEY);
};

export const clearRedirectPath = (): void => {
  sessionStorage.removeItem(REDIRECT_AFTER_AUTH_KEY);
};
